import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  constructor(private _http: HttpClient, private _store: Store<IAppState>) {}

  hasPermission(roles: string[]): Observable<boolean> {
    return this._store.pipe(
      select(selectProfile),
      map(profile => {
        if (profile && profile.groups) {
          return profile.groups.some(role => {
            return roles.includes(role) || profile.is_superuser;
          });
        } else {
          return false;
        }
      })
    );
  }

  checkPermission(profile: IUser, permission: string[]): boolean {
    if (profile && profile.groups) {
      return profile.groups.some((role: string) => {
        return permission.includes(role) || profile.is_superuser;
      });
    } else {
      return false;
    }
  }
}
